'use strict'
import { StyleSheet } from 'react-native'

module.exports = StyleSheet.create({
  bg: {
    flex: 1
  },
  container: {
    flex: 1,
    marginTop: 50,
    marginHorizontal: 20
  },
  head: {
    textAlign: 'center'
  },
  lang: {
    backgroundColor: '#fff'
  },
  button: {
    position: 'absolute',
    bottom: 40,
    width: '100%'
  },
  text: {
    fontSize: 25,
    marginTop: 20,
    lineHeight: 40
  }
})
